import { useAuth } from "../../contexts/auth/Context";
import { getDailySalesRequest } from "../requests/metrics/dailySales";
import { useQuery } from "@tanstack/react-query";
import { CACHE_TIMES } from "../../query/options";
import { DAILY_SALES_QUERY_KEY } from "../../query/keys";

interface UseDailySalesOptions {
  enabled?: boolean;
}

export const useDailySales = (options?: UseDailySalesOptions) => {
  const { token } = useAuth();

  const externalEnabled = options?.enabled ?? true;

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: DAILY_SALES_QUERY_KEY,
    queryFn: async () => {
      const data = await getDailySalesRequest(token!);
      return data;
    },
    enabled: Boolean(token) && externalEnabled,
    ...CACHE_TIMES.TRANSACTIONAL_DATA,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
